import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider } from "@tanstack/react-router";
import { registerSW } from "virtual:pwa-register";
import { router } from "./router";
import { localChanges } from "./offline/db";
import "./i18n";
import "./index.css";

registerSW({ immediate: true });

const queryClient = new QueryClient({
  defaultOptions: {
    // Offline the query functions still run: they answer from the copy on the device.
    queries: { networkMode: "always", staleTime: 30_000, refetchOnWindowFocus: false, retry: 1 },
    mutations: { networkMode: "always" },
  },
});

localChanges.addEventListener("change", () => void queryClient.invalidateQueries({ queryKey: ["local"] }));

const root = document.getElementById("root");
if (!root) throw new Error("index.html has no #root to mount on.");

createRoot(root).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  </StrictMode>,
);
